import { render, staticRenderFns } from "./BigScreenHead.vue?vue&type=template&id=0758eebc&scoped=true&"
import script from "./BigScreenHead.vue?vue&type=script&lang=js&"
export * from "./BigScreenHead.vue?vue&type=script&lang=js&"
import style0 from "./BigScreenHead.vue?vue&type=style&index=0&id=0758eebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0758eebc",
  null
  
)

export default component.exports